export const themes = {
  ltr: {
    direction: 'ltr',
    textAlign: 'left',
  },
  rtl: {
    direction: 'rtl',
    textAlign: 'right',
  },
};
